var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"design-preview",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"dp-spine"}),_vm._l((3),function(row){return _c('i',{key:row,class:['dp-row', row % 2 ? '' : 'dp-row-flipped']},[_c('b',{staticClass:"dp-photo"}),_c('b',{staticClass:"dp-pill"})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }